import { render, staticRenderFns } from "./equipmentCard.vue?vue&type=template&id=72270871&scoped=true&"
import script from "./equipmentCard.vue?vue&type=script&lang=js&"
export * from "./equipmentCard.vue?vue&type=script&lang=js&"
import style0 from "./equipmentCard.vue?vue&type=style&index=0&id=72270871&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72270871",
  null
  
)

export default component.exports